const TO_DETAIL = {
  name: 'serviceOrdersDetail',
  params: {
    id: 'id'
  }
}

const STATUS = {
  id: 'status',
  label: 'status',
  type: 'status',
  transform: 'status'
}
const ID = {
  id: 'id',
  label: 'request-number',
  type: isLink => (isLink ? 'link' : 'text'),
  link: {
    to: TO_DETAIL.name,
    params: TO_DETAIL.params
  }
}
const TYPE = {
  id: 'type',
  label: 'type',
  type: 'text',
  transform: 'type'
}
const CREATED_AT = {
  id: 'created_at',
  label: 'request-date',
  type: 'date',
  format: 'date'
}

const SERVICE_ORDERS_FIELDS = [STATUS, ID, TYPE, CREATED_AT]

export { SERVICE_ORDERS_FIELDS, TO_DETAIL, CREATED_AT }
